/**
 * Handler for redirect_to_design_gallery — opens the full-page Design Gallery,
 * optionally with a type tab (e.g. ?type=pdp or ?type=flipbooks) matching template type_* tags.
 */
export const handleRedirectToDesignGallery = ($message, { commit, dispatch } = {}) => {
  let typeFilter = '';
  try {
    const args = typeof $message.function_call.arguments === 'string'
      ? JSON.parse($message.function_call.arguments)
      : $message.function_call.arguments || {};
    if (args.type_filter) {
      typeFilter = String(args.type_filter);
    }
  } catch (e) {
    // use default empty filter
  }

  if (commit) {
    dispatch('addAndSaveMessage', {
      role: 'assistant',
      content: 'Opening the <b>Design Gallery</b>...',
    });
  }

  const qs = typeFilter ? `?type=${encodeURIComponent(typeFilter)}` : '';
  return { redirectUrl: `/design-gallery${qs}` };
};
